import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonBillComponent } from './common-bill.component';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { BillModule } from '../bill.module';
import { MatFormFieldModule, MatInputModule } from '@angular/material';

@NgModule({
	declarations: [CommonBillComponent],
	imports: [
		CommonModule,
		BillModule,
		MatInputModule,
		MatFormFieldModule,
		RouterModule.forChild([
			{
				path: '**',
				component: CommonBillComponent,
				data: SaveStateData
			}
		])
	]
})
export class CommonBillModule {}
